const sanitizeOrNull = (value) => {
    if (!value) return null;
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
};

export const parseBulkKeywords = (text) => {
    if (!text) return [];

    return text
        .split('\n')
        .map((line) => line.replace(/\r$/, ''))
        .filter((line) => line.trim().length > 0)
        .map((line) => {
            const parts = line.split('\t');
            const keyword = parts[0].trim();
            const location = parts.length > 1 ? sanitizeOrNull(parts.slice(1).join(' ')) : null;
            return { keyword, location };
        })
        .filter((entry) => entry.keyword.length > 0);
};

export const parseCategorizedKeywords = (text) => {
    if (!text) return [];

    return text
        .split('\n')
        .map((line) => line.replace(/\r$/, ''))
        .filter((line) => line.trim().length > 0)
        .map((line) => parseCategorizedLine(line))
        .filter((entry) => entry.keyword.length > 0);
};

const parseCategorizedLine = (line) => {
    if (!line.includes('\t')) {
        return { category: null, keyword: line.trim(), location: null };
    }

    const parts = line.split('\t');
    return {
        category: sanitizeOrNull(parts[0]),
        keyword: parts.slice(1).join(' ').trim(),
        location: null,
    };
};

export const parseGeolocatedKeywords = (text) => {
    if (!text) return [];

    return text
        .split('\n')
        .map((line) => line.replace(/\r$/, ''))
        .filter((line) => line.trim().length > 0)
        .map((line) => parseGeolocatedLine(line))
        .filter((entry) => entry.keyword.length > 0);
};

const parseGeolocatedLine = (line) => {
    const parts = line.split('\t');

    if (parts.length < 2) {
        return { category: null, keyword: parts[0].trim(), location: null };
    }

    if (parts.length === 2) {
        return {
            category: sanitizeOrNull(parts[0]),
            keyword: parts[1].trim(),
            location: null,
        };
    }

    return {
        category: sanitizeOrNull(parts[0]),
        keyword: parts[1].trim(),
        location: sanitizeOrNull(parts.slice(2).join(' ')),
    };
};

export const getDistinctLocations = (entries) => {
    if (!entries || entries.length === 0) return [];

    const seen = new Set();
    const distinct = [];

    entries.forEach((entry) => {
        const location = entry.location;
        if (!location) return;
        const key = location.toLowerCase();
        if (seen.has(key)) return;
        seen.add(key);
        distinct.push(location);
    });

    return distinct;
};
